import { PagedLogs } from "@/domain/entity/admin/operation-log-entity";
import { OperationLogRepository } from "@/domain/repository/operation-log-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchOperationLogUsecase {
  constructor(private readonly operationLogRepo: OperationLogRepository) {}

  async execute(page: number, pageSize: number): Promise<SATResult<PagedLogs, SATError>> {
    return this.operationLogRepo.fetchLogs(page, pageSize);
  }
}
